module.exports = __webpack_public_path__ + "img/cdm.79e7a842.gif";